import React, { Component } from 'react'
import { withNamespaces } from 'react-i18next';
import { Icon } from "@iconify/react";
import JoinUs from "../../components/JoinUs/JoinUs";
import { isDesktop } from 'react-device-detect';
import MobileCommissionPlan from './MobileCommissionPlan';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";


class CommissionPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
        return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

  render() {
    const { t } = this.props;

    const img = this.imageImport(
        require.context(
            "../../assets/images/commission/",
            false,
            /\.(png|jpe?g|svg|webp)$/
        )
    );

    const global = this.imageImport(
        require.context(
            "../../assets/images/",
            false,
            /\.(png|jpe?g|svg|webp)$/
        )
    );

    const data = [
        { amount: '1 & ' + t('commission-plan.above'), activeMembers: '< 5', rate: '13%' },
        { amount: '1 - 15,000', activeMembers: '>= 5', rate: '30%' },
        { amount: '15,001 & ' + t('commission-plan.above'), activeMembers: '>= 5', rate: '40%' },
        { amount: t('commission-plan.invitation-only'), activeMembers: '-', rate: '45%' },
    ];

    let imageLanguage = '';
    switch (this.props.currentUser.language_code) {
        case "zh-CN":
            imageLanguage = "-cn"
        break;
        // case "ms":
        //     imageLanguage = "-ms"
        //     break;
        default:
            imageLanguage = ""
        break;
    }

    return (
      <>
      {isDesktop? (
        <>
            <img style={{ width: "100%"}} src={img[`affiliate-commission-banner${imageLanguage}.webp`]} alt='affiliate commission banner'/>     

            <div className='commission'>
                <div className='x-container'>
                    <div className='commission-plan-container'>
                        <div className='d-flex justify-content-end'>
                            <button className='btn btn-gradient-blue'>
                                <img src={img['share.svg']} alt='share'/>
                                {t('promos.share')}
                            </button>
                        </div>
                        <h2 className='text-center'>{t('commission-plan.commission-plan')}</h2>

                        <div>
                            <span>{t('commission-plan.commission-issued')}</span>

                            <div className='commission-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>{t('commission-plan.member-total-win-loss-amount')}</th>
                                            <th>{t('commission-plan.active-members')}</th>
                                            <th>{t('commission-plan.commission-rate')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((row, idx) => (
                                            <tr key={idx} className={idx % 2 === 1 ? "table-alt-row" : ""}>
                                                <td>{row.amount}</td>
                                                <td>{row.activeMembers}</td>
                                                <td>{row.rate}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>                            
                            </div>

                            <ul>
                                <p>{t('commission-plan.list-label-1')}</p>
                                <li>{t('commission-plan.list-desc-1-1')}</li>
                                <li>{t('commission-plan.list-desc-1-2')}</li>
                                <li>{t('commission-plan.list-desc-1-3')}</li>
                                <li>{t('commission-plan.list-desc-1-4')}</li>
                                <li>{t('commission-plan.list-desc-1-5')}</li>
                            </ul>
                        </div>

                        <div>
                            <span>{t('commission-plan.commission-calculation-example')}</span>
                            
                            <div className='commission-table'>
                                <table className='table merge'>                               
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>{t('commission-plan.commission')} = ({t('commission-plan.total-member-profit')} - {t('commission-plan.member-bonus')} - {t('commission-plan.transfer-fees')}) x {t('commission-plan.commission-rate')} %</th>
                                            <th>{t('commission-plan.commission')} = ({t('commission-plan.total-member-profit')} - {t('commission-plan.member-bonus')} - {t('commission-plan.transfer-fees')}) x {t('commission-plan.commission-rate')} %</th>
                                        </tr>                                   
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='align-middle'>{t('commission-plan.example')}</td>         
                                            <td>
                                                <span>{t('commission-plan.positive-profits')}</span>
                                                <p>{t('commission-plan.total-member-profit')} = USD 21,000</p>
                                                <p>{t('commission-plan.member-bonus')} = USD 598 </p>
                                                <p>{t('commission-plan.transfer-fees')} = USD 273</p>
                                                <p className='pt-4'>(USD 21,000 - USD 598 - USD 273) x 40% = USD 8,051.6 ({t('commission-plan.commission')})</p>
                                            </td>
                                            <td>
                                                <span>{t('commission-plan.negative-profits')}</span>
                                                <p>{t('commission-plan.total-member-profit')} = USD - 21,000 </p>
                                                <p>{t('commission-plan.member-bonus')} = USD 598 </p>
                                                <p>{t('commission-plan.transfer-fees')} = USD 273</p>
                                                <p className='pt-4'>(USD - 21,000 - USD 598 - USD 273) x 40% = USD - 8,748.4 ({t('commission-plan.accumulate-to-next-month')})</p>
                                            </td>                               
                                        </tr>                                 
                                    </tbody>                                
                                </table>                            
                            </div>

                            <ul>
                                <li>{t('commission-plan.list-desc-1-6')}</li>
                                <li>{t('commission-plan.list-desc-1-7')}</li>
                            </ul>

                            <ul>
                                <p>{t('commission-plan.list-label-2')}</p>
                                <li>{t('commission-plan.list-desc-2-1')}</li>
                                <li>{t('commission-plan.list-desc-2-2')}</li>
                            </ul>
                        </div>

                        <div className='mt-5'>
                            <p className='text-center' style={{ fontSize: "1.125rem", color: "#2C3742", fontFamily: "MicrosoftYaHeiLobbyUI, sans-serif"}}>{t('commission-plan.sub-agent-commission-calculation-formula')}</p>
                            <div className='commission-table'>
                                <table className='table formula'>
                                    <thead>
                                        <tr>   
                                            <th>
                                                <div>
                                                    <img src={img['org-chart.webp']} alt='commission formula'/>     
                                                    <div 
                                                        className='text-container top'>
                                                        <span>{t('commission-plan.agent')} A</span>
                                                        <p>{t('commission-plan.commission')} +</p>
                                                        <p>USD 8,000</p>
                                                    </div>
                                                    <div 
                                                        className='text-container bottom-left'>
                                                        <span>{t('commission-plan.agent')} B1</span>
                                                        <p>{t('commission-plan.commission')} +</p>
                                                        <p>USD 5,000</p>
                                                    </div>
                                                    <div 
                                                        className='text-container bottom-right'>
                                                        <span>{t('commission-plan.agent')} B2</span>
                                                        <p>{t('commission-plan.commission')} +</p>
                                                        <p>USD 5,000</p>
                                                    </div>
                                                </div>
                                            </th>                                 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>{t('commission-plan.example')}:</p>
                                                <p>{t('commission-plan.agent')} A {t('commission-plan.referral')} {t('commission-plan.agent')} B1 & B2</p>
                                                <p>{t('commission-plan.commission-calculation-formula')}: 
                                                    <span> {t('commission-plan.agent')} A {t('commission-plan.commission')} + ( {t('commission-plan.sub-agent')} B1 & B2 {t('commission-plan.commission')} * 10% ) = {t('commission-plan.agent')} A {t('commission-plan.direct-commission')}</span></p>
                                                <p>USD 8,000 + ((USD 5,000 + USD 5,000) * 10%) = USD 9,000</p>
                                                <p>{t('commission-plan.agent')} A {t('commission-plan.total-commission-earned')} = USD 9,000</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>                            
                            </div>

                            <ul>
                                <p>{t('commission-plan.list-label-3')}</p>
                                <li>{t('commission-plan.list-desc-3-1')}</li>
                                <li>{t('commission-plan.list-desc-3-2')}</li>
                                <li>{t('commission-plan.list-desc-3-3')}</li>
                                <li>{t('commission-plan.list-desc-3-4')}</li>
                                <li>{t('commission-plan.list-desc-3-5')}</li>
                            </ul>

                            <ul>
                                <p>{t('commission-plan.list-label-4')}</p>
                                <li>{t('commission-plan.list-desc-4-1')}</li>
                                <li>{t('commission-plan.list-desc-4-2')}</li>
                                <li>{t('commission-plan.list-desc-4-3')}</li>
                                <li>{t('commission-plan.list-desc-4-4')}</li>
                                <li>{t('commission-plan.list-desc-4-5')}</li>
                                <li>{t('commission-plan.list-desc-4-6')}</li>
                            </ul>
                        </div>
                    </div>
                </div>    
            </div>
  
            <JoinUs />
        </>
      ):(
        <MobileCommissionPlan 
            img={img}
            global={global}
            data={data}
            {...this.state}
            {...this.props}
        />
      )}        
      </>
    )
  }
}

const mapStateToProps = (state) => {
    
    return {
        currentUser: state.currentUser.data,
    };
};

export default connect(mapStateToProps)(withRouter(withNamespaces("translation")(CommissionPlan)));
